import React from 'react';
import { Section } from './Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-sage-50" data-id="element-83">
      <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-sage-100 text-center" data-id="element-84">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-sage-100 text-sage-600 mb-6" data-id="element-85">
          <ShieldCheck size={40} data-id="element-86" />
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-87">
          Compra 100% sin riesgo
        </h2>
        <h3 className="text-xl font-medium text-sage-700 mb-6" data-id="element-88">
          Garantía de satisfacción — 7 días
        </h3>
        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-89">
          Si en los próximos 7 días abrís el kit, lo probás y sentís que no era
          para vos, nos escribís un mail y te devolvemos el 100% de tu dinero.
          Sin preguntas, sin papeleos, sin vueltas. Probalo tranquilo porque
          todo el riesgo lo ponemos nosotros.
        </p>
      </div>
    </Section>;
}